export const convertFileSizeToSizeUnits = (fileSize: number, decimals = 2): string => {
  if (!fileSize) return "0 Bytes";

  const base = 1000;
  const decimalPlaces = decimals < 0 ? 0 : decimals;
  const sizeUnits = ["Bytes", "kB", "MB", "GB", "TB"];

  const index = Math.floor(Math.log(fileSize) / Math.log(base));

  return `${parseFloat((fileSize / Math.pow(base, index)).toFixed(decimalPlaces))} ${
    sizeUnits[index]
  }`;
};
